module.exports = __webpack_public_path__ + "img/11.2e7bd2f7.png";